import { useQuery } from '@tanstack/react-query';
import {
  fetchMetricsOverview,
  fetchDORAMetrics,
  fetchProductivityMetrics,
  fetchBusinessMetrics,
  fetchMetricTrend,
} from '@/api/metrics';

export function useMetricsOverview(periodDays: number = 30) {
  return useQuery({
    queryKey: ['metrics-overview', periodDays],
    queryFn: () => fetchMetricsOverview(periodDays),
    staleTime: 5 * 60 * 1000,
  });
}

export function useDORAMetrics(periodDays: number = 30) {
  return useQuery({
    queryKey: ['dora-metrics', periodDays],
    queryFn: () => fetchDORAMetrics(periodDays),
    staleTime: 5 * 60 * 1000,
  });
}

export function useProductivityMetrics(periodDays: number = 30) {
  return useQuery({
    queryKey: ['productivity-metrics', periodDays],
    queryFn: () => fetchProductivityMetrics(periodDays),
    staleTime: 5 * 60 * 1000,
  });
}

export function useBusinessMetrics(periodDays: number = 30) {
  return useQuery({
    queryKey: ['business-metrics', periodDays],
    queryFn: () => fetchBusinessMetrics(periodDays),
    staleTime: 5 * 60 * 1000,
  });
}

export function useMetricTrend(
  category: string,
  metricName: string,
  periods: number = 6,
  granularity: string = 'monthly',
) {
  return useQuery({
    queryKey: ['metric-trend', category, metricName, periods, granularity],
    queryFn: () => fetchMetricTrend(category, metricName, periods, granularity),
    staleTime: 5 * 60 * 1000,
    enabled: !!category && !!metricName,
  });
}
